import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import Avatar from '../../components/Avatar'
import Arrow from '../../svg-icons/Arrow'
import MenuPointer from '../../svg-icons/MenuPointer'
import { Metrics, Fonts, Colors } from '../../Themes'
import placeholder from '../../../public/img/placeholder.png'

const DropdownToggleContainer = styled.div`
  display: table;
  position: relative;
  cursor: pointer;
`

const AvatarContainer = styled.div`
  display: table-cell;
  vertical-align: middle;
`

const ArrowContainer = styled.div`
  display: table-cell;
  vertical-align: middle;

  svg {
    transform: rotate(180deg);
    vertical-align: middle;
  }
`

const Menu = styled.div`
  display: ${props => (props.open ? 'block' : 'none')};
  width: 150px;
  z-index: 3;
  background: white;
  padding: ${Metrics.margins.base};
  position: absolute;
  right: 0;
  top: calc(${Metrics.margins.big} - 1px);
  border: ${Metrics.borders.default};
`

const MenuItem = styled.div`
  ${Fonts.style.Label};
  padding: ${Metrics.margins.small} 0;
  &:hover {
    color: ${Colors.primary};
  }
`

const CustomMenuPointer = styled(MenuPointer)`
  position: absolute;
  top: -12px;
  right: 30px;
  width: 25px;
`

class ProfileDropdownSettings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.toggleDropdown = this.toggleDropdown.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return this.state.open !== nextState.open
  }

  closeMenu () {
    this.setState({ open: false })
  }

  toggleDropdown () {
    this.setState({ open: !this.state.open })
  }

  render () {
    const { admin, dropdownLinks } = this.props
    return (
      <DropdownToggleContainer
        tabIndex='-1'
        onBlur={this.closeMenu}
        onClick={this.toggleDropdown}>
        <AvatarContainer>
          <Avatar
            withBorder
            size={Metrics.components.adminAvatarSize}
            imageSrc={admin.picture || placeholder}
          />
        </AvatarContainer>
        <ArrowContainer>
          <Arrow />
        </ArrowContainer>
        <Menu open={this.state.open}>
          <CustomMenuPointer />
          {dropdownLinks &&
            dropdownLinks.map((el, index) => {
              return (
                <MenuItem key={`admin-dropdown-${index}`} onClick={el.onClick}>
                  {el.label}
                </MenuItem>
              )
            })}
        </Menu>
      </DropdownToggleContainer>
    )
  }
}

ProfileDropdownSettings.propTypes = {
  admin: PropTypes.object,
  router: PropTypes.object,
  t: PropTypes.func,
  dropdownLinks: PropTypes.array
}

export default ProfileDropdownSettings



// WEBPACK FOOTER //
// ./src/components/ProfileDropdownSettings/index.js